import { Logger } from "../logging";

const isPrerender = navigator.userAgent.indexOf("RusEtfsPrerender") !== -1;

export const skipForPrerender = (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
	if (!isPrerender)
		return;

	descriptor.value = function() {
		Logger.logTrace(`[Skip:Prerender] ${target.constructor.name}.${propertyKey}`)
	};
}